import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SupportSection = () => {
  const supportOptions = [
    {
      icon: 'MessageCircle',
      title: 'Live Chat Support',
      description: 'Get instant help from our team',
      action: 'Start Chat',
      color: 'text-primary'
    },
    {
      icon: 'Mail',
      title: 'Email Support',
      description: 'support@jobfusion.com',
      action: 'Send Email',
      color: 'text-accent'
    },
    {
      icon: 'Phone',
      title: 'Phone Support',
      description: '+1 (800) 123-4567',
      action: 'Call Now',
      color: 'text-success'
    }
  ];

  const helpLinks = [
    { icon: 'FileText', label: 'Refund Policy', href: '#' },
    { icon: 'HelpCircle', label: 'FAQs', href: '#' },
    { icon: 'Book', label: 'User Guide', href: '#' },
    { icon: 'Settings', label: 'Manage Subscription', href: '#' }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-warm-sm">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Headphones" size={20} className="text-primary" />
        <h2 className="text-lg font-heading font-bold text-foreground">
          Need Help?
        </h2>
      </div>
      {/* Support Options */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {supportOptions?.map((option, index) => (
          <div
            key={index}
            className="bg-gradient-to-br from-muted/30 to-muted/10 rounded-lg p-4 border border-border hover:border-primary/50 transition-all"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-12 h-12 bg-card rounded-full flex items-center justify-center mb-3 border border-border">
                <Icon name={option?.icon} size={20} className={option?.color} />
              </div>
              <p className="font-medium text-foreground text-sm mb-1">{option?.title}</p>
              <p className="text-xs text-muted-foreground mb-3">{option?.description}</p>
              <Button variant="outline" size="sm" className="w-full">
                {option?.action}
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Help Links */}
      <div className="border-t border-border pt-6">
        <p className="text-sm font-medium text-foreground mb-4">Helpful Resources</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {helpLinks?.map((link, index) => (
            <a
              key={index}
              href={link?.href}
              className="flex items-center gap-2 p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors group"
            >
              <Icon name={link?.icon} size={16} className="text-muted-foreground group-hover:text-primary transition-colors" />
              <span className="text-sm text-foreground">{link?.label}</span>
            </a>
          ))}
        </div>
      </div>
      {/* Additional Info */}
      <div className="mt-6 bg-accent/10 rounded-lg p-4">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} className="text-accent mt-0.5 flex-shrink-0" />
          <div className="text-sm text-foreground">
            <p className="font-medium mb-1">30-Day Money-Back Guarantee</p>
            <p className="text-muted-foreground text-xs">
              Not satisfied? Request a full refund within 30 days of purchase, no questions asked.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportSection;